<template>
  <div>
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        formLayout="inline"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView>
    </a-card>

    <a-card style="margin-top:20px;">
      <div class="text-right">
        <a-button @click="$refs.createModal.add()" type="primary" icon="plus">
          新增菜单
        </a-button>
      </div>

      <!-- 结果 -->
      <TableView
        ref="table"
        :scroll="scroll"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        :loading="loading"
        @handlePagination="handlePagination"
      >
        <!--操作 slot-->
        <template v-slot:action="{ tableRow }">
          <a
            href="javascript:void(0)"
            @click="$refs.createModal.edit(tableRow)"
          >
            编辑
          </a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="此操作将删除此菜单, 是否继续?"
            @confirm="() => handleDel(tableRow)"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a href="javascript:void(0)">
              删除
            </a>
          </a-popconfirm>
        </template>
      </TableView>
    </a-card>
    <!--新增 | 维护 MODAL-->
    <create-form ref="createModal" @getTableList="_getTableData" />
  </div>
</template>

<script>
import { TableView, SearchView } from 'lxfintech-fe'
import CreateForm from './components/CreateForm'
import mixin from './mixin'
import { getMenuData, deleteMenu } from './api'
import { mapMutations } from 'vuex'
import { SET_MENUS } from 'config/mutation-types/user'
export default {
  mixins: [mixin],
  components: {
    TableView,
    CreateForm,
    SearchView,
  },
  data() {
    return {
      searchSchema: [
        {
          label: '名称',
          itemName: 'name',
          type: 'input',
          allowClear: true,
        },
      ],
      searchData: {
        name: '',
      },
      loading: '',
      tableData: [],
      scroll: { x: 1000 }, //滚动设置
      pageData: {
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      frozenText: '',
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    ...mapMutations('user', [SET_MENUS]),
    //获取table数据
    async _getTableData() {
      try {
        this.loading = true
        const { current, pageSize } = this.pageData
        const query = {
          size: pageSize,
          current,
          name: this.searchData.name,
        }
        delete query.pageSize
        const {
          data: { total, records },
        } = await getMenuData(query)
        this.tableData = records
        this.pageData.total = total
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    handelSearch(query) {
      this.searchData.name = query.name
      this.$nextTick(() => {
        this._getTableData()
      })
    },
    //分页
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)

      this._getTableData()
    },
    // 删除menu
    async handleDel(row) {
      try {
        const { data } = await deleteMenu(row.id)
        this[SET_MENUS](data)
        this._getTableData()
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
